import React from 'react'
import { CBadge, CButton, CCard, CCardBody } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import Meta from '../../shared/Meta'
import { icon } from '../../shared/icons'

function AgencyCard({ agency, detailsOpen, onToggleDetails, onOpenNewDetails }) {
  const active = String(agency.status) === '1'
  const plan = agency.payment_plan || {}

  return (
    <CCard className="card-x">
      <CCardBody>
        <div className="row-top">
          <div>
            <h3>{agency.name || 'Sin nombre'}</h3>
            <p>{agency.description || 'Sin descripcion'}</p>
          </div>
          <CBadge color={active ? 'success' : 'danger'}>{active ? 'Activa' : 'Inactiva'}</CBadge>
        </div>
        <div className="meta-grid">
          <Meta label="Parent PCC" value={agency.parent_pcc || '-'} />
          <Meta label="Usuarios" value={plan.users ?? '-'} />
          <Meta label="Custom scripts" value={plan.custom_scripts ?? '-'} />
        </div>
        <div className="agency-actions">
          <CButton color={detailsOpen ? 'success' : 'light'} size="sm" onClick={onToggleDetails}>
            <CIcon icon={icon(detailsOpen ? 'cilChevronTop' : 'cilChevronBottom')} /> PCCs y usuarios
          </CButton>
          <CButton color="success" variant="outline" size="sm" onClick={onOpenNewDetails}>
            <CIcon icon={icon('cilExternalLink')} /> PCC y usuarios (Nuevo)
          </CButton>
        </div>
      </CCardBody>
    </CCard>
  )
}

export default AgencyCard
